import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";

const lesson: Lesson = {
  id: "20dc0ae0-cb22-4e61-b5d6-efe056218e1b",
  publicId: "12",
  name: "Room and building acoustics design criteria",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [principle01, task01, task02, task03, task04],
};

export default lesson;
